export default __webpack_public_path__ + "static/media/item2.81e34ae6.png";